// @ts-nocheck
import { Product, ProductLiquid } from '@gate31/types';
import Shop from 'Shop';
import { checkContrast } from './contrast';

export function declOfNum(number, titles) {
    const cases = [ 2, 0, 1, 1, 1, 2 ];

    return titles[(number % 100 > 4 && number % 100 < 20) ? 2 : cases[(number % 10 < 5) ? number % 10 : 5]];
}

export function numWord(value, words){
    value = Math.abs(value) % 100;

    let num = value % 10;
    if(value > 10 && value < 20) return words[2];
    if(num > 1 && num < 5) return words[1];
    if(num == 1) return words[0];

    return words[2];
}

export function priceFormat(price: string | number) {
    return Shop.money.format(price).replace('руб.', '₽');
}


export function getCookie(name: string) {
    const matches = document.cookie.match(new RegExp(
        '(?:^|; )' + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)'
    ));

    return matches ? decodeURIComponent(matches[1]) : undefined;
}

export function changeProductObject(data: Product[]) {
    const newData: ProductLiquid[] = JSON.parse(JSON.stringify(data));

    Object.values(newData).forEach(product => {
        // Цена
        // if (product.variants[0].old_price) {
        //     product.variants[0].old_price = priceFormat(product.variants[0].old_price);
        // }
        // if (product.variants[0].price) {
        //     product.variants[0].price = priceFormat(product.variants[0].price);
        // }
        // if (product.variants[0].base_price) {
        //     product.variants[0].base_price = priceFormat(product.variants[0].base_price);
        // }

        // Бейджи товара
        const badge = product.properties.find(item => item.permalink === 'badge' ? item.id : undefined);
        const isShowVideo = product.properties.find(item => item.permalink === 'pokazyvat-video' ? item.id : undefined);
        const isSale = product.properties.find(item => item.permalink === 'aktsiya' ? item.id : undefined);

        let newProperties = {
            badge: {
                characteristics: [{ name: '' }]
            },
            'pokazyvat-video': {
                characteristics: []
            }
        };
        if (badge !== undefined) {
            const id = badge.id;

            newProperties = {
                badge: {
                    characteristics: product.characteristics
                        .filter(item => item.property_id === id)
                        .map(property => ({ name: property.title }))
                },
            };
        }

        if (isShowVideo !== undefined) {
            const id = isShowVideo.id;

            newProperties['pokazyvat-video'] = {
                characteristics: [
                    { name: product.characteristics.filter(item => item.property_id === id)[0].title }
                ]
            };
        }

        if (isSale !== undefined) {
            const id = isSale.id;

            newProperties['aktsiya'] = {
                characteristics: product.characteristics
                    .filter(item => item.property_id === id)
                    .map(item => ({ handle: item.permalink }))
            };
        }

        product.properties = newProperties;

        // Изображение товара
        const imgUrl = product.images[0].original_url;

        product.first_image = {
            original_url: imgUrl
        };
    });

    return newData;
}

export const validateEmail = (email) => {
    return String(email)
        .toLowerCase()
        .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
};

export const validateDateOfBirthday = (value: string | null | undefined) => {
    if (! value) {
        return false;
    }

    return /^\d{2}\.\d{2}\.\d{4}$/.test(value)
}

export const validatePhone = (value) => {
    if (! value) {
        return false;
    }

    return /^(\s*)?(\+)?([- _():=+]?\d[- _():=+]?){10,14}(\s*)?$/.test(value)
}

export function buildBackgroundColorProduct(colorArray): string {
    const colorLength = colorArray.length;

    const linearGradient = colorArray.map((color, index) => {
        const fillArea = 100 / colorLength;
        const colorStartPosition = fillArea * index;
        const colorEndPosition = fillArea * (index + 1);

        return `${color} ${colorStartPosition}% ${colorEndPosition}%`
    }).join(', ')

    return `linear-gradient(90deg, ${linearGradient})`;
}

export function svgBorderData(hexArr, strokeColor = '#EDEDED', strokeSize = 2):
    | { type: 'circle', radius: number, strokeSize: number, strokeColor: string }
    | { type: 'path', rotation: number, path: string, strokeSize: number, strokeColor: string } {

    let isNeedBorder = false;
    let colorIndex: number;
    if (hexArr) {
        hexArr.forEach((hex, i) => {
            if (hex && ! isNeedBorder) {
                isNeedBorder = ! checkContrast(hex, '#FAFAFA');
                colorIndex = isNeedBorder ? i + 1 : colorIndex;
            }
        });
    }

    if (isNeedBorder) {
        const center = 26 / 2;
        const radius = center;
        const angle = 360 / hexArr.length;
        const rad = (angle * Math.PI) / 180;

        if (angle === 360) {
            return {type: 'circle', radius, strokeColor, strokeSize}
        } else {
            const x = center + radius * Math.sin(rad);
            const y = center - radius * Math.cos(rad);
            const path = `
                M ${center} ${0}
                A ${radius} ${radius} 0 0 1 ${x.toFixed(2)} ${y.toFixed(2)}
                Z
                `;

            return {type: 'path', rotation: colorIndex * angle, path, strokeColor, strokeSize}
        }
    }
}

export function parseTableByRows(table: HTMLTableElement) {
    const tableRows = table?.tBodies.item(0)?.rows
    const tHeadCells = table?.tHead?.rows?.[0]?.cells;

    const rows: string[][] = [];

    if (tHeadCells?.length) {
        const row: string[] = [];
        for (const cellEl of tHeadCells) {
            row.push(cellEl.textContent);
        }
        rows.push(row);
    }

    for (const rowEl of tableRows) {
        const row: string[] = [];
        for (const cellEl of rowEl.cells) {
            row.push(cellEl.textContent ?? '');
        }
        rows.push(row);
    }

    return rows;
}

export function parseTableByColumns(table: HTMLTableElement) {
    const tableRows = table?.tBodies.item(0)?.rows;
    const tHeadCells = table?.tHead?.rows?.[0]?.cells;

    const columnCount = tHeadCells?.length ?? tableRows?.item(0)?.cells?.length ?? 0;

    const columns: string[][] = [];

    for (let colIndex = 0; colIndex < columnCount; colIndex++) {
        const col: string[] = [];

        if (tHeadCells?.length) {
            col.push(tHeadCells.item(colIndex)?.textContent ?? '');
        }

        for (const rowEl of tableRows) {
            col.push(rowEl.cells.item(colIndex)?.textContent ?? '');
        }

        columns.push(col);
    }

    return columns;
}